import { withTranslation } from 'react-i18next';
import ContentWrapper from '@components/ContentWrapper';
import { ISelectUserAvatarPageViewProps } from './interfaces';
import SelectAvatarContent from '@core/avatar/components/SelectAvatarContent';
import RevokeConsent from '@features/avaturn/components/RevokeConsent';

const SelectUserAvatarPageView = ({
  t: translate,
  avatars,
  selectedAvatar,
  setSelectedAvatar,
  onRevokeConsent,
}: ISelectUserAvatarPageViewProps) => {
  return (
    <ContentWrapper
      subtitle={translate('userAvatarPage.subtitle')}
      text={translate('userAvatarPage.text')}
      forceKeepSubtitle={true}
    >
      <SelectAvatarContent
        avatars={avatars}
        setSelectedAvatar={setSelectedAvatar}
        selectedAvatar={selectedAvatar}
      />
      <RevokeConsent onRevokeConsent={onRevokeConsent} />
    </ContentWrapper>
  );
};

export default withTranslation()(SelectUserAvatarPageView);
